import {fork} from 'redux-saga/effects';

import {isDieselRoute} from '../hocs/diesel-route/DieselRoute';
import {isDieselReducer} from '../decorators/DieselReducer';
import {isDieselSaga} from '../decorators/DieselSaga';

export default class PluginRegistry {
    constructor(plugins) {
        this.plugins = plugins || [];
    }

    getReducers() {
        const reducers = this.plugins.filter(plugin => isDieselReducer(plugin));
        return reducers || [];
    }

    getSagas() {
        const sagas = this.plugins.filter(plugin => isDieselSaga(plugin));

        if (!sagas.length) return false;

        return function* forkSagas() {
            for (let i = 0; i < sagas.length; i++) {
                yield fork(sagas[i]);
            }
        };
    }

    getReducerMap() {
        const reducerList = this.plugins.filter(plugin => isDieselReducer(plugin));
        const reducers = {};
        for (const reducer of reducerList) {
            reducers[reducer.reducerName] = reducer;
        }
        return reducers;
    }

    getRouteDefinitions() {
        const routeDefinitions = this.plugins
            .filter(plugin => isDieselRoute(plugin))
            .map(plugin => plugin.getDieselRouteDefinition());

        return routeDefinitions || [];
    }

    providePlugin(plugin) {
        this.plugins.push(plugin);
    }

    getRootComponent() {
        return this.rootComponent;
    }

    setRootComponent(rootComponent) {
        this.rootComponent = rootComponent;
    }

    get plugins() {
        return this._plugins;
    }

    set plugins(plugins) {
        if (Array.isArray(plugins)) {
            this._plugins = [...plugins];
        } else if (plugins) {
            this._plugins = [plugins];
        } else {
            this._plugins = [];
        }
    }
}
